import { render } from "./NoteTagList.vue?vue&type=template&id=33cdc2b1"
import script from "./NoteTagList.vue?vue&type=script&lang=js"
export * from "./NoteTagList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__